module.exports = __webpack_public_path__ + "img/QP.d0c91de4.png";